import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './ResetPin.css';
import API_BASE_URL from '../../config/api';

const ResetPin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('Link inválido. Por favor solicite um novo email de recuperação.');
    }
  }, [token]);

  const handlePinInput = (setter) => (e) => {
    const val = e.target.value.replace(/\D/g, '');
    if (val.length <= 4) setter(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (newPin.length !== 4) {
      setError('O PIN deve ter exatamente 4 dígitos.');
      return;
    }
    if (newPin !== confirmPin) {
      setError('Os PINs não coincidem.');
      return;
    }

    setIsLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/auth/reset-pin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPin }),
      });

      if (res.ok) {
        setSuccess(true);
        setTimeout(() => navigate('/login'), 3000);
      } else {
        const data = await res.json();
        setError(data.message || 'Link inválido ou expirado.');
      }
    } catch {
      setError('Erro de ligação ao servidor. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="reset-pin-page">
      <div className="reset-pin-card">
        <div className="reset-pin-header">
          <div className="reset-pin-icon">🔑</div>
          <h1>Redefinir PIN</h1>
          <p>Crie um novo PIN de 4 dígitos para aceder à sua dashboard.</p>
        </div>

        {success ? (
          <div className="reset-pin-success">
            <div className="success-icon">✅</div>
            <h2>PIN redefinido com sucesso!</h2>
            <p>Será redirecionado para o login em breve...</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="reset-pin-form">
            {error && (
              <div className="reset-pin-error">{error}</div>
            )}

            <div className="reset-pin-field">
              <label>Novo PIN</label>
              <input
                type="password"
                inputMode="numeric"
                maxLength={4}
                value={newPin}
                onChange={handlePinInput(setNewPin)}
                placeholder="••••"
                disabled={isLoading || !token}
                autoComplete="off"
                autoFocus
              />
            </div>

            <div className="reset-pin-field">
              <label>Confirmar PIN</label>
              <input
                type="password"
                inputMode="numeric"
                maxLength={4}
                value={confirmPin}
                onChange={handlePinInput(setConfirmPin)}
                placeholder="••••"
                disabled={isLoading || !token}
                autoComplete="off"
              />
            </div>

            <button
              type="submit"
              className="reset-pin-btn"
              disabled={isLoading || !token || newPin.length !== 4 || confirmPin.length !== 4}
            >
              {isLoading ? 'A guardar...' : 'Guardar novo PIN'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ResetPin;
